import { handleError } from "../../../utils/handleError";
import store from "../../../redux/store";
import { updateFpAppV4Data } from "../../../redux/fpAppV4Slice";
import { queryClient } from "@/ReactQuery/reactQueryClient";
import { clearProductTimeout, setProductTimeout } from "@/utils/productTimers";

// Helper function to wait for query submission (HTTP request received by backend)
const waitForQuerySubmission = (qid) => {
  return new Promise((resolve, reject) => {
    const timeout = setProductTimeout(() => {
      cleanup();
      reject(new Error(`Query ${qid} submission timed out after 10 seconds`));
    }, 10000);

    const checkSubmission = () => {
      const queryAnswers = store.getState().fpAppV4Data.queryAnswers;
      const queryAnswer = queryAnswers.find((qa) => qa.qid === qid);

      // Wait for "queued" status - this comes from backend WebSocket after HTTP request is processed
      if (queryAnswer && queryAnswer.status === "queued") {
        cleanup();
        resolve(queryAnswer);
      }
    };

    // Subscribe to Redux store changes
    const unsubscribe = store.subscribe(checkSubmission);

    const cleanup = () => {
      clearProductTimeout(timeout);
      unsubscribe();
    };

    // Check immediately in case it's already submitted
    checkSubmission();
  });
};

const executeUnexecutedQueriesOfWorkspace = async (
  editor,
  setShowRunAllQueryBtn
) => {
  try {
    if (!editor) {
      editor = window.fp?.editor;
    }
    const userDocs = queryClient.getQueryData(["orgFileList"]) || [];
    const fpAppV4Data = store.getState().fpAppV4Data;

    if (fpAppV4Data.type === "private_doc_editor") {
      // if (userDocs.length === 0) {
      //   alert("Please upload at least one document to execute queries");
      //   return;
      // }
    }
    setShowRunAllQueryBtn(false);
    const url = new URL(window.location.href);
    if (url.searchParams.get("src") === "template") {
      url.searchParams.delete("src");
      window.history.pushState({}, "", url.href);
    }

    let queries = fpAppV4Data.queries;
    const queryAnswers = fpAppV4Data.queryAnswers;

    if (queries) {
      // get the right order of the queries from the editor
      const queryNodes = [];
      editor.state.doc.descendants((node, pos) => {
        if (node.type.name === "queryInput") {
          queryNodes.push({ node, pos });
        }
      });

      let numQueries = 0;
      for (const { node } of queryNodes) {
        const qid = node.attrs.qid;
        if (
          !qid ||
          queryAnswers.find((queryAnswer) => queryAnswer.qid === qid)
        ) {
          continue;
        }

        if (!queries[qid]?.startExecution) {
          numQueries++;
        }
      }

      for (const { node } of queryNodes) {
        const qid = node.attrs.qid;
        if (
          !qid ||
          queryAnswers.find((queryAnswer) => queryAnswer.qid === qid)
        ) {
          continue;
        }

        if (!queries[qid]?.startExecution) {
          store.dispatch(
            updateFpAppV4Data({
              queries: {
                ...queries,
                [qid]: {
                  ...queries[qid],
                  startExecution: numQueries,
                },
              },
            })
          );

          // Wait for the query to be processed by backend (status becomes "queued")
          try {
            await waitForQuerySubmission(qid);
            console.log(`Query ${qid} successfully submitted`);
          } catch (submissionError) {
            console.warn(
              `Query ${qid} submission failed:`,
              submissionError.message
            );
            // Continue with next query even if this one fails to submit
          }

          // Refresh queries state after this query is processed
          queries = store.getState().fpAppV4Data.queries;
        }
      }
    }
  } catch (error) {
    handleError({
      error,
      location: "executeUnexecutedQueriesOfWorkspace",
    });
  }
};

export default executeUnexecutedQueriesOfWorkspace;
